module.exports = __webpack_public_path__ + "static/img/hainan-tcm-hospital.1e7797d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/hainan-tcm-hospital.png
// module id = 43U1
// module chunks = 1 2